// extracted by mini-css-extract-plugin
module.exports = {"container":"StatusesRulesValidationContent_container__1gtrp","results":"StatusesRulesValidationContent_results__dCV64","header":"StatusesRulesValidationContent_header__3Zz6n"};